import { render, staticRenderFns } from "./OrganizationDetails.vue?vue&type=template&id=289fb76b&scoped=true"
import script from "./OrganizationDetails.vue?vue&type=script&lang=ts"
export * from "./OrganizationDetails.vue?vue&type=script&lang=ts"
import style0 from "./OrganizationDetails.vue?vue&type=style&index=0&id=289fb76b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289fb76b",
  null
  
)

export default component.exports